import type { TGetSimulacaoDuplicarResponse } from '@/features/simulacao/interfaces/simulacao.type'
import { HttpService } from '@/shared/lib/http'

export class GetSimulacaoDuplicarService extends HttpService {
  execute = async (simulacaoId: string) => {
    return this.http.get<TGetSimulacaoDuplicarResponse>(`/api/v2/Simulacao/${simulacaoId}/duplicar`)
  }
}
